import React from 'react';
import { FeedEvent } from 'types/interfaces/followingFeed';
import { WantAddedCard } from './WantAddedCard';
import { TradeEventCard } from './TradeEventCard';
import { MilestoneEarnedCard } from './MilestoneEarnedCard';

interface FeedEventCardProps {
  event: FeedEvent;
}

export const FeedEventCard: React.FC<FeedEventCardProps> = ({ event }) => {
  switch (event.type) {
    case 'WANT_ADDED':
      return <WantAddedCard event={event} />;
    case 'TRADE_INITIATED':
    case 'TRADE_SHIPPED':
    case 'TRADE_COMPLETED':
      return <TradeEventCard event={event} />;
    case 'MILESTONE_EARNED':
      return <MilestoneEarnedCard event={event} />;
    default:
      return null;
  }
};

export default FeedEventCard;
